module.exports = __webpack_public_path__ + "img/berkeley-building.88b018dc.jpg";